module.exports = __webpack_public_path__ + "static/media/01.3ea37f4d.png";